/** Categorías de la matriz Cash Flow (desktop + móvil). */
export function getCashFlowCategories(data, formatValue) {
  const exportSaldo =
    Object.values(data || {}).reduce((acc, d) => acc + (d.exportacion || 0), 0) +
    400000;
  const importSaldo =
    Object.values(data || {}).reduce((acc, d) => acc + (d.importacion || 0), 0) +
    200000;

  return [
    { key: "pedidosVenta", label: "PEDIDOS VENTA", mobileLabel: "Pedidos venta" },
    { key: "albaranesVenta", label: "ALBARANES VENTA", mobileLabel: "Albaranes venta" },
    {
      key: "facturasVenta",
      label: "FACTURAS VENTA - CARTERA",
      mobileLabel: "Facturas venta",
    },
    { key: "pedidosCompra", label: "PEDIDOS COMPRA", mobileLabel: "Pedidos compra" },
    { key: "albaranesCompra", label: "ALBARANES COMPRA", mobileLabel: "Albaranes compra" },
    {
      key: "facturasCompra",
      label: "FACTURAS DE COMPRA - CARTERA",
      mobileLabel: "Facturas compra",
    },
    { key: "nominas", label: "NÓMINAS", mobileLabel: "Nóminas" },
    { key: "ss", label: "SS", mobileLabel: "SS" },
    { key: "irpf", label: "IRPF", mobileLabel: "IRPF" },
    { key: "proyecciones", label: "PROYECCIONES VENTA", mobileLabel: "Proy. venta" },
    {
      key: "proyeccionesCompra",
      label: "PROYECCIONES COMPRA",
      mobileLabel: "Proy. compra",
    },
    { key: "pagoReal", label: "IVA - A PAGAR / DEVOLVER", mobileLabel: "IVA pagar/devolver" },
    { key: "ivaTrimestral", label: "IVA TRIMESTRAL", mobileLabel: "IVA trimestral" },
    { key: "is", label: "IMPUESTO SOCIEDADES", mobileLabel: "Imp. sociedades" },
    { key: "euro100", label: "SALDO 572.1", mobileLabel: "Saldo 572.1", tone: "balance" },
    { key: "caixa_usd", label: "SALDO 572.5 USD", mobileLabel: "Saldo 572.5 USD", tone: "balance" },
    {
      key: "exportacionvista",
      label: `SALDO EXPORT: ${formatValue(exportSaldo)}`,
      mobileLabel: `Saldo export: ${formatValue(exportSaldo)}`,
      tone: "balance",
    },
    {
      key: "importacionvista",
      label: `SALDO IMPORT: ${formatValue(importSaldo)}`,
      mobileLabel: `Saldo import: ${formatValue(importSaldo)}`,
      tone: "balance",
    },
    { key: "revolut", label: "SALDO REVOLUT", mobileLabel: "Saldo Revolut", tone: "balance" },
    { key: "cashFlowDia", label: "CF (día)", mobileLabel: "CF día", tone: "cfDay" },
    { key: "cashFlowAcum", label: "CF ACUMULADO", mobileLabel: "CF acumulado", tone: "cfAcum" },
  ];
}

export function getCategoryRowColors(theme, key) {
  if (
    key === "euro100" ||
    key === "caixa_usd" ||
    key === "revolut" ||
    key === "exportacion" ||
    key === "exportacionvista" ||
    key === "importacionvista"
  ) {
    return {
      rowBg: theme.palette.cfazul1?.main,
      stickyBg: theme.palette.cfazul?.main,
    };
  }
  if (key === "cashFlowDia") {
    return {
      rowBg: theme.palette.cfverde1?.main,
      stickyBg: theme.palette.cfverde?.main,
    };
  }
  if (key === "cashFlowAcum") {
    return {
      rowBg: theme.palette.cfvnaranja1?.main,
      stickyBg: theme.palette.cfvnaranja?.main,
    };
  }
  return { rowBg: undefined, stickyBg: theme.palette.cashFlow };
}
